import { createBaseDevice } from './shared'

const isGenericAlarm = (floorDevice) => String(floorDevice.id_generic ?? '').startsWith('alarm-')

export const genericAdapter = {
  name: 'generic',
  matches: () => true,
  normalize(floorDevice, context) {
    const baseDevice = createBaseDevice(floorDevice, context)
    const alarm = isGenericAlarm(floorDevice)
      ? context.relations.alarms[floorDevice.id_generic] ?? null
      : null

    if (!alarm) return baseDevice

    return {
      ...baseDevice,
      id: floorDevice.id_generic,
      name: alarm.name,
      kind: 'alarm',
      device_type: 'alarm',
      camera_type: 'alarm',
      icon: alarm.icon,
      color: alarm.color,
      color_icon: alarm.color_icon,
      text_color: alarm.text_color,
      acronym: alarm.acronym,
      active_alarm: alarm.active_alarm,
      can_update_alarm: alarm.can_update_alarm,
      dispatch_url: alarm.dispatch_url,
      cancel_url: alarm.cancel_url,
    }
  },
}
